<div [innerHTML]="html ?? '' | safeHtml"></div>
